import * as User from '../../constants/User/Show'
import axios from 'axios';

import * as SG from '../../constants/AppSettings'
import { noticeAdd, loadEnd, loadStart } from '../App';
// import { getMyCircle } from '../User/CircleList'

export function userInfoGet(userId) {
  return dispatch => {

    dispatch(loadStart())

    axios.get(SG.USER_SHOW_URL.replace(/:id/, userId)).then(res => {
      dispatch(userInfoGetResult(res.data.user))
      dispatch(loadEnd())
    }).catch(res => {
      dispatch(loadEnd())
      dispatch(noticeAdd(res.response.messages, 'error'))
      dispatch(userInfoGetResult(false))
    })

    return {
      type: User.USER_INFO_GET
    }
  }
}

export function userCircleGet(userId) {
  return dispatch => {
    // dispatch(circleLoadStart())

    const requestUrl = SG.USER_COMMUNITIES_LIST_URL.replace(/:id/, userId)

    axios.get(requestUrl).then((r) => {
      // dispatch(circleLoadEnd())
      dispatch(userCircleGetResult(r.data))
    }).catch((r) => {
      dispatch(noticeAdd('サークル情報を読み込めませんでした', 'error'))
      // dispatch(circleLoadEnd())
      dispatch(userCircleGetResult(false))
    });
    return {
      type: User.USER_COMMUNITY_GET
    }
  }
}

export function userCircleGetResult(response) {
  return {
    type: User.USER_COMMUNITY_GET_RESULT,
    response
  }
}

export function userInfoGetResult(response){
  return {
    type: User.USER_INFO_GET_RESULT,
    response
  }
}

export function userInfoGetReset() {
  return {
    type: User.USER_INFO_GET_RESET
  }
}


// WEBPACK FOOTER //
// ./src/actions/User/Show.js